/*
 * @Author: chengyu
 * @Date: 2022-10-12 19:45:40
 * @Description: 描述
 */
import { getDebug } from '../config';
// 错误超时时间 2s
import { mapLog } from '../utils/logger';
/**
 * 超限标记时间
 *
 * - 标准状态下 2s
 * - 调试状态下 10s
 */
function getReGeoTimeout() {
    if (getDebug()) {
        return 1000 * 10;
    }
    return 1000 * 2;
}
// 逆地理错误码 10020 超限报错
var reGeoErrorCode = [10020];
/**
 * 逆地理缓存
 */
var RgcContext = /** @class */ (function () {
    function RgcContext() {
        /**
         * 自研逆地理服务 超限报错
         */
        this.overError = false;
    }
    /**
     * 判断是否超限
     */
    RgcContext.prototype.setOverError = function (infoCode) {
        if (reGeoErrorCode.indexOf(infoCode) > -1) {
            this.overError = true;
            this.resetOverError();
            mapLog('自研超限...');
        }
    };
    /**
     * 重置超限状态
     */
    RgcContext.prototype.resetOverError = function () {
        var _this = this;
        var reGeoTimeout = getReGeoTimeout();
        clearTimeout(this.overTimer);
        this.overTimer = setTimeout(function () {
            _this.overError = false;
            mapLog('标记时间已过，重置超限状态');
        }, reGeoTimeout);
    };
    return RgcContext;
}());
export { RgcContext };
var FetchContext = /** @class */ (function () {
    function FetchContext(options) {
        var rgc = (options || {}).rgc;
        this.rgc = rgc;
        this.startTime = new Date().getTime();
    }
    /**
     * 设置body
     * @param body
     */
    FetchContext.prototype.setBody = function (body) {
        this.body = body || {};
    };
    FetchContext.prototype.setArg0 = function (arg0) {
        this.arg0 = arg0 || {};
    };
    return FetchContext;
}());
export { FetchContext };
export function createContext(options) {
    return new FetchContext(options);
}
export function createRgcContext() {
    return new RgcContext();
}
//# sourceMappingURL=data:application/json;base64,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